@if (hasConfig(task)) {
    <form #settingsForm="ngForm" [id]="task.ClassName+'form'">
        @if (task.Instructions) {
            <mat-panel-description style="margin-bottom:16px">
                {{ task.Instructions }}
            </mat-panel-description>
        }
        @for (setting of task.AvailableConfigurationSettings.PropertyEditModels; track setting.PropertyName) {
            <div>
                @if (setting.ControlType === 'text' || setting.ControlType === 'modulepicker') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <input [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                               [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                               [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput type="text"/>
                    </mat-form-field>
                    <br/>
                }
                @if (setting.ControlType === 'integer') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <input [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                               [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                               [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput step="1" type="number"/>
                    </mat-form-field>
                    <br/>
                }
                @if (setting.ControlType === 'textarea') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <textarea [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                                  [name]="task.ClassName+setting.PropertyName"
                                  [placeholder]="setting.Label" [required]="setting.Mandatory"
                                  [attr.aria-label]="setting.Label" matInput></textarea>
                    </mat-form-field>
                    <br/>
                }
                @if (setting.ControlType === 'boolean') {
                    <mat-checkbox [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                                  [name]="task.ClassName+setting.PropertyName" [required]="setting.Mandatory">
                        {{ setting.Label }}
                    </mat-checkbox>
                    <br/><br/>
                }
                @if (setting.ControlType === 'password') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <input [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                               [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                               [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput type="password"/>
                    </mat-form-field>
                    <br/>
                }
                @if (setting.ControlType === 'dropdown') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <mat-select [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                                    [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                                    [required]="setting.Mandatory">
                            <mat-option [value]="null"></mat-option>
                            @for (val of setting.Values; track val) {
                                <mat-option [value]="val">{{ val | pascalToHuman }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <br/>
                }
                @if (setting.ControlType === 'radiobutton') {
                    <label [for]="task.ClassName + setting.PropertyName">{{ setting.Label }}</label>
                    <br/>
                    <mat-radio-group [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                                     [id]="task.ClassName + setting.PropertyName"
                                     [name]="task.ClassName+setting.PropertyName"
                                     [required]="setting.Mandatory">
                        @for (val of setting.Values; track val) {
                            <mat-radio-button [value]="val">{{ val | pascalToHuman }}</mat-radio-button>
                        }
                    </mat-radio-group>
                    <br/><br/>
                }
                @if (setting.ControlType === 'dictionary') {
                    <span>{{ setting.Label }}</span>
                    <table>
                        <thead>
                            <tr>
                                <th>Key</th>
                                <th>Value</th>
                                <th>Options</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (key of generateDictionary(task.DefaultConfiguration, setting.PropertyName); track key) {
                                <tr>
                                    <td>{{ key }}</td>
                                    <td>
                                        <mat-form-field appearance="fill">
                                            <input [(ngModel)]="task.DefaultConfiguration[setting.PropertyName][key]"
                                                   [name]="'dictionaryProperty_'+key" [attr.aria-label]="'Dictionary value for ' + key" matInput/>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <a (click)="removeRow(task.DefaultConfiguration[setting.PropertyName], key)"
                                           id="maintenace-editor-delete-row-item-{{key}}" mat-button>
                                            <mat-icon>delete</mat-icon>
                                        </a>
                                    </td>
                                </tr>
                            }
                            <tr>
                                <td>
                                    <mat-form-field floatLabel="never">
                                        <input [(ngModel)]="setting.newKey" id="newDictionaryKeyInput" matInput name="newDictionaryKey" aria-label="New dictionary key"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field floatLabel="never">
                                        <input [(ngModel)]="setting.newValue" id="newDictionaryValueInput" matInput name="newDictionaryValue" aria-label="New dictionary value"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <a (click)="newValuePair(task.DefaultConfiguration[setting.PropertyName], setting.newKey, setting.newValue, setting)"
                                       class="mat-accent" mat-raised-button>
                                        &nbsp;<mat-icon>add</mat-icon>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                }
                @if (setting.ControlType === 'stringarray') {
                    <span>{{ setting.Label }}</span>
                    <table>
                        <thead>
                            <tr>
                                <th>Key</th>
                                <th>Options</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (s of generateArray(task.DefaultConfiguration, setting.PropertyName); track $index) {
                                <tr>
                                    <td>{{ s }}</td>
                                    <td>
                                        <a (click)="removeRow(task.DefaultConfiguration[setting.PropertyName], s)"
                                           id="maintenace-editor-delete-row-item-{{s}}" mat-button>
                                            <mat-icon>delete</mat-icon>
                                        </a>
                                    </td>
                                </tr>
                            }
                            <tr>
                                <td>
                                    <mat-form-field floatLabel="never">
                                        <input [(ngModel)]="setting.newItem" id="newArrayItemInput" matInput name="newArrayitem" aria-label="New array item"/>
                                    </mat-form-field>
                                    <a (click)="newArrayItem(task.DefaultConfiguration[setting.PropertyName], setting.newItem, setting)"
                                       class="mat-accent" mat-raised-button>
                                        &nbsp;<mat-icon>add</mat-icon>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                }
                @if (setting.ControlType === 'datepicker') {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ setting.Label }}</mat-label>
                        <input [(ngModel)]="task.DefaultConfiguration[setting.PropertyName]"
                               [name]="task.ClassName+setting.PropertyName"
                               [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput type="date">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                    </mat-form-field>
                    <br/>
                }
            </div>
        }
    </form>
}
